module.exports = __webpack_public_path__ + "img/image(2)-1.4d5efd24.png";